import { slugify } from '../../src/utils/string/index.ts'
import { capitalize, pxToRem } from './utils.mjs'
/**
 * @enum {number}
 */
export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1440,
  '3xl': 1920
}

export const colors = {
  black: {
    DEFAULT: '#000',
  },
  grey: {
    DEFAULT: '#CFCFCF',
    100: '#EFEBE9',
    200: '#CFCFCF',
    300: '#5F5F5F',
    400: '#BAB9B9',
    500: '#7D7D7D',
    600: '#555555',
    700: '#2C2C2C',
  },
  white: {
    DEFAULT: '#fff',
  }
}

/**
 * Default app fonts.
 *
 * The proerty `alternativeName` is optional and will be used as the font name in the CSS.
 * If not provided, the `name` property will be used.
 * The property `path` is relative to `@src/assets/fonts/` folder
 */
export const fonts = [
  { alternativeName: undefined, name: 'Museo Sans', path: 'museo-sans/300', weight: 300 },
  { alternativeName: undefined, name: 'Museo Sans', path: 'museo-sans/500', weight: 500 },
  { alternativeName: undefined, name: 'Museo Sans', path: 'museo-sans/700', weight: 700 },
]

/**
 * Format fonts for UnoCSS.
 *
 * Your fonts will become a slugified version of the `name` with `font` prefix.
 *
 * @example Roboto -> font-roboto
 */
export const formatFonts = (_fonts = fonts) => {
  return _fonts.reduce((acc, font) => {
    const name = font.alternativeName || font.name
    acc[slugify(name)] = name
    return acc
  }, {})
}

const breakpointsEntries = Object.entries(breakpoints)
/**
 * @typedef {{[k in keyof typeof breakpoints as `at${Capitalize<k>}`]: {min?: string, max?: string}}} OnlyValues
 * @typedef {{[k in keyof typeof breakpoints as `lt${Capitalize<k>}`]: {min?: string, max?: string}}} BeforeValues
 * @typedef {{[k in keyof typeof breakpoints]: string}} Values
 *
 * @typedef {OnlyValues & BeforeValues & Values} Breakpoints
 *
 * @type {Breakpoints}
 */
// @ts-expect-error we are building this object
export const screens = breakpointsEntries.reduce((acc, [name, value], i) => {
  const nextBreakpoint = breakpointsEntries[i + 1]
  acc[name] = pxToRem(value)
  acc[`at${capitalize(name)}`] = nextBreakpoint
    ? { min: pxToRem(value), max: pxToRem(nextBreakpoint[1] - 1) }
    : { min: pxToRem(value) }

  acc[`lt${capitalize(name)}`] = { max: pxToRem(value - 1) }
  return acc
}, {})

export default {
  breakpoints: breakpointsEntries.reduce((acc, [name, value], i) => {
    acc[name] = pxToRem(value)
    return acc
  }, {}),
  colors,
  fontFamily: formatFonts()
}
